export default function PlaceholderImage({ filename, width = 800, height = 600, alt = '', className = '' }) {
  const ratio = (height / width) * 100

  return (
    <div
      className={`relative overflow-hidden rounded-2xl bg-slate-50 border border-slate-200 ${className}`}
      style={{ paddingBottom: `${ratio}%` }}
      role="img"
      aria-label={alt || filename}
    >
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 p-4">
        <div className="text-4xl opacity-20">🖼️</div>
        <p className="font-display font-semibold text-slate-400 text-center text-xs sm:text-sm break-all">{filename}</p>
        <p className="text-xs text-slate-300">{width} × {height}px</p>
      </div>
    </div>
  )
}
